export default __webpack_public_path__ + "static/media/messNull.96bb74a5.png";